import { useProvinceContext } from '../../../contexts/ProvinceProvider';
import AcademiaFilterSelect from '../../CommonComps/Inputs/AcademiaFilterSelect';
import AcademiaSearchInput from '../../CommonComps/Inputs/AcademiaSearchInput';

const FilterProvincesDiv = () => {
  // integration of context hooks here
  const {
    provinceAddedCountries,
    setFilterCountry,
    searchText,
    setSearchText,
  } = useProvinceContext();

  // rendering filter provinces component here
  return (
    <div className='flex flex-col md:flex-row items-center gap-3 justify-between mb-5 bg-legal-dark-blue shadow-academia-sm rounded-lg p-3'>
      <div
        className={`bg-base-white shadow-academia-sm w-full md:w-fit rounded-lg`}
      >
        <div className='w-1/5 min-w-full md:min-w-[280px]'>
          <AcademiaSearchInput
            searchText={searchText}
            setSearchText={setSearchText}
            inputLabel='Search Province...'
            removeBorder
          />
        </div>
      </div>

      <AcademiaFilterSelect
        options={['All', ...provinceAddedCountries]}
        onChangeHandler={(country) => setFilterCountry(country)}
      />
    </div>
  );
};

export default FilterProvincesDiv;
